import React, { useEffect, useState } from "react";
import {
  Typography,
  Box,
  Divider,
  Button,
  Grid,
  TextField,
  InputLabel,
  Stack,
  Card,
  CardContent
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import moment from "moment";
import axios from "axios";
// import {ReactComponent as AddImage} from '../../../Icons/Add.svg'
import { width } from "@mui/system";
import PostAddIcon from "@mui/icons-material/PostAdd";
import { ReactComponent as FormIcon } from "../../../Icons/CommonFormIcon.svg";
import { useDispatch, useSelector } from "react-redux";
import axiosInstance from "../../../api/axiosInstance";
import { removeData } from "../../../Redux/Feature/AdminSlice";
import dayjs from "dayjs";
import { Autocomplete } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";

export default function StudentReportAdd() {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const allLanguages = useSelector((state) => state.language.languageList)
  console.log(allLanguages)
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState(null);
  console.log(selectedStudent)

  const {
    control,
    formState: { errors },
    handleSubmit,
    setValue
  } = useForm({
    mode: "onTouched",
  });


  const headerDatas = {
    title : '',
    subtitle : ''
  }

  const [activeLanguagesHeader, setActiveLanguagesHeader] = useState(allLanguages);

  const [header, setHeader] = useState({
    en : { ...headerDatas }
  })


  useEffect(() => {
  const fetchStudents = async () => {
    try {
      const res = await axiosInstance.get(
        `${process.env.REACT_APP_API_URL}get-all-users`
      );
      setStudents(res?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };

  fetchStudents();
}, []);


const fetchStudentDetails = async (id) => {
  try {
    const res = await axiosInstance.get(
      `${process.env.REACT_APP_API_URL}get-paiduser-by-id/${id}`
    );

    const student = res?.data?.data;

    if (student) {
      // Personal Information
      setValue("hostelName", student?.RoomsData?.selectedRoom?.HostelName);
      setValue("gender", student?.userData?.gender);
      setValue("name", student?.userData?.name);
      // setValue("dob", student?.userData?.dob);
      setValue("dob", student?.userData?.dob ? dayjs(student?.userData?.dob) : null);
      setValue("roomNo", student.roomNo);
      setValue("allowanceBalance", student.allowanceBalance);

      // Academic Info
      setValue("school", student.school);
      setValue("grade", student?.userData?.grade);
      setValue("attendance", student.attendance);
      setValue("studySituation", student.studySituation);
      setValue("extracurricularActivities", student.extracurricularActivities);

      // Evaluation & Development
      setValue("accommodation", student.accommodation);
      setValue("diet", student.diet);
      setValue("interpersonalRelationship", student.interpersonalRelationship);
      setValue("lifeCounselling", student.lifeCounselling);
      setValue("psychologicalCounselling", student.psychologicalCounselling);
      setValue("tuitionSituation", student.tuitionSituation);
      setValue("remark", student.remark);

      // Person In Charge
      setValue("personInCharge", student.personInCharge);
    }
  } catch (error) {
    console.log(error);
  }
};


  const addHeaderLanguage = () => {
    const nextLanguage = allLanguages.find(lang => !activeLanguagesHeader.some(active => active.value === lang.value))
    if(nextLanguage){
      setActiveLanguagesHeader((prev) => [...prev, nextLanguage])
      setHeader((prev => ({...prev, [nextLanguage.value] : { ...headerDatas }})))
    }
}

const handleHeadingChange = (e, lang, key) => {
  setHeader((prev) => ({
    ...prev,
    [lang]: {
      ...(prev[lang] || { ...headerDatas }),
      [key]: e.target.value,
    },
  }));
};

  const onSubmit = async (data) => {
    console.log(data);

    const datas = {
      title: data?.title,
      subtitle: data?.subtitle,
      date: moment(data?.dateTime?.$d).format("DD-MM-YYYY,hh:mm A"),
    };

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_API_URL}add-parent-report`,
        {data : {...data,
          date: moment(data?.dateTime?.$d).format("DD-MM-YYYY,hh:mm A"),
          dob: moment(data?.dob?.$d).format("DD-MM-YYYY"),
          email : selectedStudent?.email,
          student_id : selectedStudent?._id
        }}
      );
      console.log(response);
      navigate("/Admin/student-report");
    } catch (error) {
      console.log(error);
      if(error.response.status === 401 || error.response.status === 403){
        navigate('/Admin/login')
        dispatch(removeData())
    }
    }
  };

  console.log(selectedStudent)

  return (
    <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Card sx={{ width: '80%', border:'1px solid #E5E7EB', borderRadius:"6px"}}>
        <CardContent style={{ padding: 0, margin: 0 }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              backgroundColor: "#FCFCFD",
              padding: 2,
              border:'1px solid #E5E7EB',
              borderRadius:'6px 6px 0px 0px'
              
            }}
          >
            <FormIcon style={{ marginRight: "10px" }} />
            <Typography variant="h6_1">Hostel Student Report</Typography>
          </Box>

          {/* <Divider /> */}
          <form onSubmit={handleSubmit(onSubmit)}>
          
            <Box sx={{}} >
            {/* <Typography sx={{fontWeight : 700, fontSize : '1.4rem', mt : 2, ml : 2}}>{lang.name}</Typography> */}
            {/* <Box style={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                {errors?.title ? 'Title*' : 'Title'}
              </InputLabel>
              <Controller
                name={`title`}
                rules={{ required: true }}
                control={control}
                // label={`Title (${lang.label})`}
                render={({ field }) => (
                  <TextField
                    placeholder={`Title`}
                    sx={{ 
                      mt: 0, 
                      backgroundColor : 'rgb(249, 250, 251)',
                      borderRadius: 0, 
                      "& .MuiInputBase-input": {
                        color: errors?.title ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.title ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.title ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.title ? "#ff5e74" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    error={Boolean(errors?.title) ? true : false}
                    {...field}
                  />
                )}
              />
              {errors?.title ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please enter title</Typography> : null }
            </Box> */}
            <Typography sx={{ fontWeight: 700, fontSize: "1.2rem", mt: 3, ml : 2 }}>
  Personal Information
</Typography>

            <Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Student Email*
              </InputLabel>

              <Autocomplete
                options={students}
                getOptionLabel={(option) => option.email || ""}
                value={selectedStudent}
                onChange={(event, newValue) => {
                  setSelectedStudent(newValue);
                  if (newValue?._id) {
                    fetchStudentDetails(newValue._id);
                  }
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Student"
                    sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.af ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.af ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.af ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.af ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                  />
                )}
              />
            </Box>
            <Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Name
              </InputLabel>

              <Controller
  name="name"
  control={control}
  render={({ field }) => (
    <TextField {...field} sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.name ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.name ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.name ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.name ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>
            <Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Hostel Name*
              </InputLabel>

              <Controller
  name="hostelName"
  control={control}
  render={({ field }) => (
    <TextField {...field} sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.hostelName ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.hostelName ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.hostelName ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.hostelName ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>
            <Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Gender
              </InputLabel>

              <Controller
              
  name="gender"
  control={control}
  render={({ field }) => (
    <TextField disabled {...field} sx={{
      
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.gender ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.gender ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.gender ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.gender ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>
           
            <Box sx={{ padding: "25px 17px 17px 17px" }}>
  <InputLabel
    sx={{
      mb: 1,
      fontSize: "18px",
      fontWeight: 600,
      color: "black",
    }}
  >
    Date of Birth
  </InputLabel>

  <Controller
    name="dob"
    control={control}
    render={({ field }) => (
      <DatePicker
      disabled
        value={field.value ? dayjs(field.value) : null}
        onChange={(newValue) => {
          field.onChange(newValue);
        }}
        format="DD/MM/YYYY"
        maxDate={dayjs()}   // cannot select future date
        renderInput={(params) => (
          <TextField
            {...params}
            fullWidth
            sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.dob ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.dob ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.dob ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.dob ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
          />
        )}
      />
    )}
  />
</Box>
            
            <Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Room Number
              </InputLabel>

              <Controller
  name="roomNo"
  control={control}
  render={({ field }) => (
    <TextField {...field} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.roomNo ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.roomNo ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.roomNo ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.roomNo ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>
            
            <Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Allowance Balance
              </InputLabel>

              <Controller
  name="allowanceBalance"
  control={control}
  render={({ field }) => (
    <TextField {...field}  fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.allowanceBalance ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.allowanceBalance ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.allowanceBalance ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.allowanceBalance ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>

            <Divider sx={{mt : 2, mb : 2}}/>

            <Typography sx={{ fontWeight: 700, fontSize: "1.2rem", mt: 3, ml : 2 }}>
  Academic Info
</Typography>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                School
              </InputLabel>

              <Controller
  name="school"
  control={control}
  render={({ field }) => (
    <TextField {...field} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.school ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.school ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.school ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.school ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Grade/Course
              </InputLabel>

              <Controller
  name="grade"
  control={control}
  render={({ field }) => (
    <TextField {...field} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.grade ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.grade ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.grade ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.grade ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Attendance Situation
              </InputLabel>

              <Controller
  name="attendance"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.attendance ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.attendance ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.attendance ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.attendance ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Study Situation
              </InputLabel>

              <Controller
  name="studySituation"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.studySituation ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.studySituation ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.studySituation ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.studySituation ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Extracurricular Activities
              </InputLabel>

              <Controller
  name="extracurricularActivities"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.extracurricularActivities ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.extracurricularActivities ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.extracurricularActivities ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.extracurricularActivities ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>


<Divider sx={{mt : 2, mb : 2}}/>


<Typography sx={{ fontWeight: 700, fontSize: "1.2rem", mt: 3, ml : 2 }}>
  Evalution & Development
</Typography>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Accommodation Situation
              </InputLabel>

              <Controller
  name="accommodation"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.accommodation ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.accommodation ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.accommodation ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.accommodation ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>
<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Diet Situation
              </InputLabel>

              <Controller
  name="diet"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.diet ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.diet ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.diet ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.diet ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>
<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Interpersonal Relationships
              </InputLabel>

              <Controller
  name="interpersonalRelationship"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.interpersonalRelationship ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.interpersonalRelationship ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.interpersonalRelationship ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.interpersonalRelationship ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Life Counselling
              </InputLabel>

              <Controller
  name="lifeCounselling"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.lifeCounselling ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.lifeCounselling ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.lifeCounselling ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.lifeCounselling ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Psychological Counselling
              </InputLabel>

              <Controller
  name="psychologicalCounselling"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.psychologicalCounselling ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.psychologicalCounselling ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.psychologicalCounselling ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.psychologicalCounselling ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Tuition Situation
              </InputLabel>

              <Controller
  name="tuitionSituation"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.tuitionSituation ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.tuitionSituation ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.tuitionSituation ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.tuitionSituation ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }} />
  )}
/>
            </Box>

<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Remark
              </InputLabel>

              <Controller
  name="remark"
  control={control}
  render={({ field }) => (
    <TextField {...field} multiline rows={3} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.remark ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.remark ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.remark ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.remark ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}/>
  )}
/>
            </Box>


<Divider sx={{mt : 2, mb : 2}}/>


<Box sx={{ padding: "25px 17px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: "black",
                }}
              >
                Person in Charge
              </InputLabel>

              <Controller
  name="personInCharge"
  control={control}
  render={({ field }) => (
    <TextField {...field} fullWidth sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.personInCharge ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.personInCharge ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.personInCharge ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.personInCharge ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}/>
  )}
/>
            </Box>

            </Box>
          

          {/* <Box sx={{mt : 2, mb: 2, ml : 2}}>
          <Button variant='contained' onClick={() => addHeaderLanguage()}>Add Language</Button>
          </Box> */}


            <Box style={{ padding: "0px 17px 17px" }}>
              <InputLabel
                sx={{
                  mb: 1,
                  mt: 3,
                  fontSize: "18px",
                  fontWeight: 600,
                  color: 'black',
                }}
              >
                {errors?.dateTime ? 'Date & Time*' : 'Date & Time'}
              </InputLabel>
              <Controller
                name="dateTime"
                rules={{ required: true }}
                
                control={control}
                render={({ field }) => (
                  <DateTimePicker
                    {...field}
                    // label="Select Date and Time"

                    renderInput={(props) => (
                      <TextField
                        {...props}
                        error={Boolean(errors?.dateTime) ? true : false}
                        fullWidth
                        inputMode="none"
                        inputProps={{
                          ...props.inputProps,
                          placeholder: "DD/MM/YYYY HH:MM AA",
                        }}
                      />
                    )}
                    sx={{
                      backgroundColor : 'rgb(249, 250, 251)',
                      width: "100%",
                      ".MuiSvgIcon-root": { fill: "#1A2461" },
                      "& .MuiInputBase-input": {
                        color: errors?.dateTime ? "red" : "black",
                      },
                      "& .MuiOutlinedInput-root": {
                        "& fieldset": {
                          borderColor: errors?.dateTime ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&:hover fieldset": {
                          borderColor: errors?.dateTime ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                        "&.Mui-focused fieldset": {
                          borderColor: errors?.dateTime ? "red" : "rgba(0, 0, 0, 0.23)",
                        },
                      },
                    }}
                    format="DD/MM/YYYY hh:mm A"
                    minDateTime={dayjs()}
                  />
                  
                )}
                
              />
              {errors?.dateTime ? <Typography style={{color : '#ff5e74', margin : '0.3rem'}}>Please select Date and Time</Typography> : null }
            </Box>
            <Divider style={{marginTop : '15px'}}/>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                padding: "0px 17px 13px",
              }}
            >
              <Button
                variant="contained"
                type="submit"
                sx={{
                  padding: "10px 20px 10px 20px",
                  mt: 2,
                  width: "20%",
                  fontSize: 20,
                  backgroundColor: "rgb(14, 94, 132)",
                  ":hover": { bgcolor: "rgb(14, 94, 132)" },
                }}
              >
                Confirm
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
